import React, { Suspense } from 'react'
import './App.css'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { Auth0Provider, withAuthenticationRequired } from '@auth0/auth0-react'
import { ModalProvider } from './common/modal/modalContext'
import Logout from './logout/Logout'
import packageJson from '../package.json'
global.appVersion = packageJson.version

// Lazy loading of home introduced to prevent websocket being started before redirect to authentication (bodge?)
const Home = React.lazy(() => import('./home/Home'))

// This site has 3 pages, all of which are rendered
// dynamically in the browser (not server rendered).
//
// Although the page does not ever refresh, notice how
// React Router keeps the URL up to date as you navigate
// through the site. This preserves the browser history,
// making sure things like the back button and bookmarks
// work properly.

const ProtectedRoute = ({ children }) => {
  const ProtectedComponent = withAuthenticationRequired(() => children, {
    onRedirecting: () => null
  })
  return <ProtectedComponent />
}

// TODO: Add spinner in home suspense fallback component
export default function App() {
  return (
    <Auth0Provider
      domain={window.AUTH0_DOMAIN}
      clientId={window.AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: "https://portal.sentosashipbrokers.com"
      }}
      useRefreshTokens={true}
      cacheLocation="memory"
    >
      <Router>
        <ProtectedRoute>
          <Route exact path="/">
            <Suspense fallback={''}>
              <ModalProvider>
                <Home />
              </ModalProvider>
            </Suspense>
          </Route>
        </ProtectedRoute>
        <ProtectedRoute>
          <Route exact path="/board/:boardId">
            <Suspense fallback={''}>
              <ModalProvider>
                <Home />
              </ModalProvider>
            </Suspense>
          </Route>
        </ProtectedRoute>
        <ProtectedRoute>
          <Route exact path="/board/:boardId/route/:boardRouteId">
            <Suspense fallback={''}>
              <ModalProvider>
                <Home />
              </ModalProvider>
            </Suspense>
          </Route>
        </ProtectedRoute>
        <Route exact path="/logout" component={Logout} />
      </Router>
    </Auth0Provider>
  )
}